import React from 'react';

export const OrderContext = React.createContext({});

export default OrderContext;